<agpr-dialog-container
    [id]="id"
    class="dialog"
    heading="Discover.distribution.saveLockSearchDialog.confirmLock"
    [modal]="true"
    [draggable]="false"
    (close)="closeDialog(false)"
>
    <div
        class="dialog-content"
        [agprLoading]="loading"
    >
        <span>
            {{ 'Discover.distribution.saveLockSearchDialog.name' | localize }}
        </span>

        <agpr-text-input
            [id]="id + '_distributionName'"
            label="Discover.dialogs.distributionName.description"
            [(ngModel)]="distName"
            placeholder="Discover.dialogs.distributionName.placeholder"
            [maxLength]="64"
            [required]="true"
            [initialFocus]="true"
        ></agpr-text-input>
        <ul  [id]="id +'_errorMessages'">
            <li>
                <agpr-form-message *ngIf="nameExistsError">
                    {{ 'Discover.targeting.distribution.error.duplicate' | localize }}
                </agpr-form-message>
                <agpr-form-message *ngIf="nameRequiredError">
                    {{ 'Discover.distribution.saveLockSearchDialog.error.required' | localize }}
                </agpr-form-message>
            </li>
        </ul>
    </div>
    <ng-template #footerLeft>
        <agpr-button
            [id]="id + '_cancelButton'"
            label="Core.button.cancel"
            [style]="buttonTypes.secondary"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            [id]="id + '_saveLockButton'"
            label="Discover.distribution.saveLockSearchDialog.saveAndLock"
            [style]="buttonTypes.primary"
            (click)="confirm()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
